(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    /* ── Auto-submit native (server-side) filters + sort ──
       Derived facets carry data-facet and are handled in-page, so they must not
       trigger a form submit. */
    var form = document.getElementById('col-filter-form');
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.hasAttribute('data-facet')) return;
        if (e.target.matches('input[type="checkbox"], select, input[type="number"]')) {
          form.submit();
        }
      });
    }

    /* ── Derived facets (material / colour / configuration) ──
       These filter the rendered cards in-page. Values are compared as whole
       pipe-delimited segments so "Full Set" cannot match "Full Set + Trunk
       Liner". Within a group the test is OR; across groups it is AND. */
    var facetInputs = Array.prototype.slice.call(document.querySelectorAll('[data-facet]'));
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-card]'));
    var countEl = document.querySelector('[data-count-live]');
    var emptyEl = document.querySelector('[data-facet-empty]');
    var clearBtns = Array.prototype.slice.call(document.querySelectorAll('[data-facet-clear]'));
    var gridEl = document.getElementById('col-grid');

    function selectedByGroup() {
      var groups = {};
      facetInputs.forEach(function (input) {
        if (!input.checked) return;
        var g = input.getAttribute('data-facet');
        (groups[g] = groups[g] || []).push(input.value);
      });
      return groups;
    }

    function cardMatches(card, groups) {
      for (var group in groups) {
        if (!Object.prototype.hasOwnProperty.call(groups, group)) continue;
        var bag = card.getAttribute('data-' + group) || '|';
        var hit = groups[group].some(function (value) {
          return bag.indexOf('|' + value + '|') !== -1;
        });
        if (!hit) return false;
      }
      return true;
    }

    function applyFacets() {
      var groups = selectedByGroup();
      var active = Object.keys(groups).length > 0;
      var visible = 0;

      cards.forEach(function (card) {
        var show = !active || cardMatches(card, groups);
        card.hidden = !show;
        if (show) visible++;
      });

      if (countEl) {
        countEl.textContent = visible + ' Product' + (visible === 1 ? '' : 's');
      }
      if (emptyEl) emptyEl.hidden = visible !== 0;
      if (gridEl) gridEl.hidden = visible === 0;

      clearBtns.forEach(function (b) {
        if (b.classList.contains('col-sidebar__clear')) b.hidden = !active;
      });
    }

    facetInputs.forEach(function (input) {
      input.addEventListener('change', applyFacets);
    });

    clearBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        facetInputs.forEach(function (input) { input.checked = false; });
        applyFacets();
      });
    });

    /* Category links carry facets as query params (?material=TPE+All+Weather),
       so a link can pre-apply a filter and stay shareable. */
    function preselectFromQuery() {
      var params = new URLSearchParams(window.location.search);
      var applied = false;
      ['material', 'color', 'config'].forEach(function (group) {
        var raw = params.get(group);
        if (!raw) return;
        var wanted = raw.split(',').map(function (v) { return v.trim().toLowerCase(); });
        facetInputs.forEach(function (input) {
          if (input.getAttribute('data-facet') !== group) return;
          if (wanted.indexOf(input.value.toLowerCase()) !== -1) {
            input.checked = true;
            applied = true;
          }
        });
      });
      return applied;
    }

    /* Highlight whichever category link matches the current URL. */
    function markActiveCategory() {
      var here = window.location.pathname + window.location.search;
      var links = Array.prototype.slice.call(document.querySelectorAll('.col-cats__link'));
      var matched = null;
      links.forEach(function (link) {
        var href = link.getAttribute('href') || '';
        if (href === here || decodeURIComponent(href) === decodeURIComponent(here)) matched = link;
      });
      if (!matched) return;
      links.forEach(function (link) {
        var on = link === matched;
        link.classList.toggle('is-active', on);
        if (on) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
    }

    if (facetInputs.length) {
      preselectFromQuery();
      applyFacets();
    }
    markActiveCategory();

    /* ── Grid / list view toggle ── */
    var grid = document.getElementById('col-grid');
    var viewBtns = Array.prototype.slice.call(document.querySelectorAll('[data-view]'));

    function setView(view) {
      if (grid) grid.classList.toggle('col-grid--list', view === 'list');
      viewBtns.forEach(function (b) {
        var on = b.dataset.view === view;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      try { localStorage.setItem('col-view', view); } catch (e) {}
    }

    var savedView = 'grid';
    try { savedView = localStorage.getItem('col-view') || 'grid'; } catch (e) {}
    setView(savedView);

    viewBtns.forEach(function (b) {
      b.addEventListener('click', function () { setView(b.dataset.view); });
    });

    /* ── Mobile filter drawer ── */
    var sidebar = document.getElementById('col-sidebar');
    var backdrop = document.querySelector('.col-sidebar-backdrop');

    function openSidebar() {
      if (!sidebar) return;
      sidebar.classList.add('is-open');
      if (backdrop) backdrop.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeSidebar() {
      if (!sidebar) return;
      sidebar.classList.remove('is-open');
      if (backdrop) backdrop.hidden = true;
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-sidebar-open]').forEach(function (b) {
      b.addEventListener('click', openSidebar);
    });
    document.querySelectorAll('[data-sidebar-close]').forEach(function (b) {
      b.addEventListener('click', closeSidebar);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitment-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /*
     * Fitment data → real product handles (see product-import/haulex-products.csv).
     * Each model lists its products with the year range each one fits.
     * `max: null` means open-ended (that year onward).
     */
    var COLLECTION_URL = '/collections/seat-covers';

    var DATA = {
      ford: {
        f150: { label: 'F-150', products: [
          { handle: '2009-2014-ford-f150-custom-seat-covers', min: 2009, max: 2014 },
          { handle: '2015-2020-ford-f150-custom-seat-covers', min: 2015, max: 2020 },
          { handle: '2021-ford-f150-custom-seat-covers',      min: 2021, max: null }
        ] }
      },
      chevrolet: {
        silverado: { label: 'Silverado', products: [
          { handle: '2007-2013-chevy-silverado-custom-seat-covers', min: 2007, max: 2013 },
          { handle: '2014-2018-chevy-silverado-custom-seat-covers', min: 2014, max: 2018 },
          { handle: '2019-chevy-silverado-custom-seat-covers',      min: 2019, max: null }
        ] }
      },
      gmc: {
        sierra: { label: 'Sierra', products: [
          { handle: '2014-2018-gmc-sierra-custom-seat-covers', min: 2014, max: 2018 },
          { handle: '2019-gmc-sierra-custom-seat-covers',      min: 2019, max: null }
        ] }
      },
      dodge: {
        'ram-1500':    { label: 'Ram 1500',    products: [
          { handle: '2019-dodge-ram-1500-custom-seat-covers', min: 2019, max: null }
        ] },
        'ram-2500':    { label: 'Ram 2500',    products: [
          { handle: '2019-dodge-ram-2500-custom-seat-covers', min: 2019, max: null }
        ] },
        'ram-classic': { label: 'Ram Classic', products: [
          { handle: '2009-dodge-ram-classic-custom-seat-covers', min: 2009, max: null }
        ] }
      },
      toyota: {
        tacoma: { label: 'Tacoma', products: [
          { handle: '2016-2023-toyota-tacoma-custom-seat-covers', min: 2016, max: 2023 },
          { handle: '2024-toyota-tacoma-custom-seat-covers',      min: 2024, max: null }
        ] },
        tundra: { label: 'Tundra', products: [
          { handle: '2013-2021-toyota-tundra-custom-seat-covers', min: 2013, max: 2021 },
          { handle: '2022-toyota-tundra-custom-seat-covers',      min: 2022, max: null }
        ] }
      }
    };

    function initBar(bar) {
      var yearSelect  = bar.querySelector('[data-fitment="year"]');
      var makeSelect  = bar.querySelector('[data-fitment="make"]');
      var modelSelect = bar.querySelector('[data-fitment="model"]');
      var submitBtn   = bar.querySelector('[data-fitment="submit"]');

      if (!makeSelect || !modelSelect || !submitBtn) return;

      makeSelect.addEventListener('change', function () {
        var models = DATA[this.value] || {};
        var keys = Object.keys(models);

        modelSelect.innerHTML = keys.length
          ? '<option value="">Model</option>'
          : '<option value="">Select Make First</option>';

        keys.forEach(function (key) {
          var opt = document.createElement('option');
          opt.value = key;
          opt.textContent = models[key].label;
          modelSelect.appendChild(opt);
        });

        modelSelect.disabled = keys.length === 0;
      });

      submitBtn.addEventListener('click', function () {
        var make = makeSelect.value;
        var modelKey = modelSelect.value;
        var year = parseInt(yearSelect ? yearSelect.value : '', 10);

        // DATA[make] is a map of modelKey -> model object.
        var model = make && modelKey && DATA[make] ? DATA[make][modelKey] : null;

        if (!model) {
          // Not enough info to match a product — send them to browse all covers.
          window.location.href = COLLECTION_URL;
          return;
        }

        var products = model.products;
        var match = null;

        if (year) {
          for (var i = 0; i < products.length; i++) {
            var p = products[i];
            if (year >= p.min && (p.max === null || year <= p.max)) {
              match = p;
              break;
            }
          }
        } else {
          // No year chosen: default to the newest (open-ended) product.
          match = products[products.length - 1];
        }

        window.location.href = match
          ? '/products/' + match.handle
          : COLLECTION_URL;
      });
    }

    function init() {
      document.querySelectorAll('.fitment-bar').forEach(initBar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-hx-header]');
    if (!header) return;

    /* ── Publish the header height so sticky offsets and scroll-padding can
          track it without hardcoding a number. ── */
    function measure() {
      document.documentElement.style.setProperty(
        '--hx-header-h',
        header.offsetHeight + 'px'
      );
    }
    measure();
    window.addEventListener('resize', measure);
    if (window.ResizeObserver) new ResizeObserver(measure).observe(header);

    /* ── Sticky: hide on scroll down, show on scroll up ── */
    var lastY = window.scrollY;
    var ticking = false;

    function onScroll() {
      var y = window.scrollY;
      var delta = y - lastY;

      // Ignore jitter, and never hide at the very top of the page.
      if (Math.abs(delta) > 4) {
        if (delta > 0 && y > header.offsetHeight) {
          header.classList.add('hx-header--hidden');
        } else if (delta < 0) {
          header.classList.remove('hx-header--hidden');
        }
        lastY = y;
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(onScroll);
      }
    }, { passive: true });

    /* ── Cart count ──
       Rendered server-side on every request, which covers this theme's
       full-page add-to-cart. refresh() re-reads /cart.js so an AJAX cart added
       later updates the header without touching this file. */
    function setCount(n) {
      document.querySelectorAll('[data-hx-cart-count]').forEach(function (el) {
        el.textContent = n;
      });
    }

    function refreshCount() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (cart) setCount(cart.item_count);
          return cart;
        })
        .catch(function () { return null; });
    }

    window.HaulexCartCount = { set: setCount, refresh: refreshCount };
    document.addEventListener('cart:updated', function () { refreshCount(); });

    /* ── Mega menu ──
       Hover opens, leaving the whole item closes after a short delay so the
       pointer can travel from the link down into the panel. Keyboard uses
       Enter/Space to open (the trigger is also a real link, so a plain click
       still navigates), Escape to close, and traps Tab inside an open panel. */
    var megaItems = document.querySelectorAll('[data-hx-mega-item]');
    var CLOSE_DELAY = 100;
    var openMega = null;

    megaItems.forEach(function (item) {
      var trigger = item.querySelector('[data-hx-mega-trigger]');
      var panel = item.querySelector('[data-hx-mega]');
      if (!trigger || !panel) return;

      var timer = null;
      /* Mega panels and the smaller preview cards use the same open/close
         logic; only the class name differs. */
      var OPEN_CLASS = panel.classList.contains('hx-card')
        ? 'hx-card--open'
        : 'hx-mega--open';

      function isOpen() {
        return panel.classList.contains(OPEN_CLASS);
      }

      function panelLinks() {
        return Array.prototype.slice.call(panel.querySelectorAll('a[href]'));
      }

      function open() {
        clearTimeout(timer);
        if (openMega && openMega !== close) openMega();
        panel.classList.add(OPEN_CLASS);
        trigger.setAttribute('aria-expanded', 'true');
        openMega = close;
      }

      function close() {
        clearTimeout(timer);
        panel.classList.remove(OPEN_CLASS);
        trigger.setAttribute('aria-expanded', 'false');
        if (openMega === close) openMega = null;
      }

      function closeSoon() {
        clearTimeout(timer);
        timer = setTimeout(close, CLOSE_DELAY);
      }

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', closeSoon);
      /* Re-entering the panel before the timer fires cancels the close. */
      panel.addEventListener('mouseenter', function () { clearTimeout(timer); });

      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          if (!isOpen()) {
            open();
            var links = panelLinks();
            if (links.length) links[0].focus();
          } else {
            close();
          }
        }
      });

      item.addEventListener('keydown', function (e) {
        if (!isOpen()) return;

        if (e.key === 'Escape') {
          e.preventDefault();
          close();
          trigger.focus();
          return;
        }

        if (e.key !== 'Tab') return;

        var links = panelLinks();
        if (!links.length) return;

        var first = links[0];
        var last = links[links.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          trigger.focus();
          close();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          close();
        }
      });
    });

    /* A click anywhere outside an open panel dismisses it. */
    document.addEventListener('click', function (e) {
      if (!openMega) return;
      if (!e.target.closest || !e.target.closest('[data-hx-mega-item]')) openMega();
    });

    /* ── Drawer ── */
    var drawer = document.querySelector('[data-hx-drawer]');
    var openBtn = document.querySelector('[data-hx-drawer-open]');
    if (!drawer || !openBtn) return;

    var panel = drawer.querySelector('.hx-drawer__panel');
    var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

    function focusable() {
      return Array.prototype.filter.call(
        panel.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
    }

    function openDrawer() {
      drawer.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var items = focusable();
      if (items.length) items[0].focus();
    }

    function closeDrawer() {
      drawer.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      openBtn.focus();
    }

    openBtn.addEventListener('click', openDrawer);

    drawer.querySelectorAll('[data-hx-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    /* Accordion for child links. */
    drawer.querySelectorAll('[data-hx-drawer-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = document.getElementById(btn.getAttribute('aria-controls'));
        if (!sub) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        sub.hidden = open;
      });
    });

    /* Escape closes; Tab is trapped inside the panel. */
    document.addEventListener('keydown', function (e) {
      if (drawer.hidden) return;

      if (e.key === 'Escape') {
        e.preventDefault();
        closeDrawer();
        return;
      }

      if (e.key !== 'Tab') return;

      var items = focusable();
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (!panel.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  (function () {
    const SECTION_ID = 'main-cart-items';

    function root() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function setBusy(state) {
      const page = document.getElementById('MainCart');
      if (page) page.setAttribute('aria-busy', state ? 'true' : 'false');
    }

    // Swap the section's inner HTML with freshly rendered markup.
    function applySection(html) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.getElementById('MainCart');
      const current = document.getElementById('MainCart');
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
    }

    async function post(url, body) {
      setBusy(true);
      try {
        body.sections = SECTION_ID;
        body.sections_url = window.location.pathname;
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await res.json();
        if (data.sections && data.sections[SECTION_ID]) {
          applySection(data.sections[SECTION_ID]);
        }
      } catch (e) {
        console.error('Cart update failed', e);
      } finally {
        setBusy(false);
      }
    }

    function changeLine(key, quantity) {
      post(root() + 'cart/change.js', { id: key, quantity: quantity });
    }

    // Event delegation on the persistent #MainCart container so listeners
    // survive innerHTML swaps.
    const container = document.getElementById('MainCart');
    if (!container) return;

    container.addEventListener('click', function (e) {
      const minus = e.target.closest('[data-qty-minus]');
      const plus = e.target.closest('[data-qty-plus]');
      const remove = e.target.closest('[data-remove]');
      const applyDiscount = e.target.closest('[data-discount-apply]');

      if (minus || plus) {
        const input = (minus || plus).parentElement.querySelector('[data-qty-input]');
        let qty = parseInt(input.value, 10) || 0;
        qty = plus ? qty + 1 : Math.max(0, qty - 1);
        changeLine(input.dataset.lineKey, qty);
      } else if (remove) {
        changeLine(remove.dataset.lineKey, 0);
      } else if (applyDiscount) {
        const code = (document.getElementById('CartDiscountCode') || {}).value;
        if (code && code.trim()) {
          window.location.href = root() + 'discount/' + encodeURIComponent(code.trim()) + '?redirect=/cart';
        }
      }
    });

    container.addEventListener('change', function (e) {
      const input = e.target.closest('[data-qty-input]');
      if (input) {
        const qty = Math.max(0, parseInt(input.value, 10) || 0);
        changeLine(input.dataset.lineKey, qty);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
    (function () {
      var popup = document.getElementById('nl-popup');
      if (!popup) return;

      var STORAGE_KEY = 'haulex_nl_popup_v1';
      var designMode = window.Shopify && window.Shopify.designMode;

      function dismissed() {
        try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
      }
      function markDismissed() {
        try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
      }

      // In the theme editor, always preview and never persist a flag.
      if (dismissed() && !designMode) return;

      var dialog = popup.querySelector('.nl-popup__dialog');
      var form = document.getElementById('nl-popup-form');
      var formPanel = popup.querySelector('[data-nl-state="form"]');
      var successPanel = popup.querySelector('[data-nl-state="success"]');
      var shown = false;

      function open() {
        if (shown) return;
        shown = true;
        popup.hidden = false;
        // next frame so the transition runs
        requestAnimationFrame(function () { popup.classList.add('is-open'); });
        document.body.style.overflow = 'hidden';
        if (!designMode) markDismissed();
        var email = document.getElementById('nl-popup-email');
        if (email) { setTimeout(function () { email.focus(); }, 300); }
      }

      function close() {
        popup.classList.remove('is-open');
        document.body.style.overflow = '';
        setTimeout(function () { popup.hidden = true; }, 280);
      }

      function showSuccess() {
        if (formPanel) formPanel.hidden = true;
        if (successPanel) successPanel.hidden = false;
        markDismissed();
        setTimeout(close, 2600);
      }

      /* ── Triggers ── */
      var delay = (parseFloat(popup.dataset.delay) || 4) * 1000;
      var timer = setTimeout(open, delay);

      if (popup.dataset.exitIntent === 'true' && !('ontouchstart' in window)) {
        document.addEventListener('mouseout', function (e) {
          if (e.clientY <= 0 && !shown) { clearTimeout(timer); open(); }
        });
      }

      /* ── Close handlers ── */
      popup.querySelectorAll('[data-nl-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && shown && !popup.hidden) close();
      });

      /* ── Submit → Shopify customer form (AJAX, native fallback) ── */
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch || !window.FormData) return; // let it submit normally
          e.preventDefault();
          var data = new FormData(form);
          fetch(form.action, {
            method: 'POST',
            body: data,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          })
            .then(function () { showSuccess(); })
            .catch(function () { form.submit(); });
        });
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-floor-mats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-fm-pdp]');
    if (!root) return;

    /* ── Gallery thumbnails ── */
    var mainImg = document.getElementById('fm-main-img');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-fm-thumb]'));
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) {
          mainImg.src = thumb.dataset.src;
          mainImg.alt = thumb.dataset.alt || '';
        }
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });

    /* ── Shared state ── */
    var atcBtn = document.getElementById('fm-atc');
    var atcLabel = document.getElementById('fm-atc-label');
    var hiddenId = document.getElementById('fm-variant-id');
    var priceEl = document.getElementById('fm-price');
    var compareEl = document.getElementById('fm-compare');
    var saveEl = document.getElementById('fm-save');

    var variantsRoot = document.getElementById('fm-variants');
    var variantData = [];
    var variantsEl = root.querySelector('[data-fm-variants]');
    if (variantsEl) {
      try { variantData = JSON.parse(variantsEl.textContent); } catch (e) { variantData = []; }
    }

    var maxPos = 0;
    var selected = [];
    if (variantsRoot) {
      var optBtns = Array.prototype.slice.call(variantsRoot.querySelectorAll('.pdp-swatch, .pdp-optbtn'));
      optBtns.forEach(function (b) {
        var p = parseInt(b.dataset.fmOptPos, 10);
        if (p > maxPos) maxPos = p;
      });
      for (var i = 1; i <= maxPos; i++) {
        var active = variantsRoot.querySelector('.is-active[data-fm-opt-pos="' + i + '"]');
        selected[i] = active ? active.dataset.fmOptValue : null;
      }
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function currentVariant() {
      if (!variantData.length) return null;
      if (!maxPos) return variantData[0];
      for (var i = 0; i < variantData.length; i++) {
        var v = variantData[i], ok = true;
        for (var p = 1; p <= maxPos; p++) {
          if (selected[p] && v['option' + p] !== selected[p]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    /* ── Vehicle selector ── */
    var vsel = root.querySelector('[data-vsel]');
    var vehicle = { year: '', make: '', model: '' };

    function vehicleComplete() {
      return !!(vehicle.year && vehicle.make && vehicle.model);
    }

    function vehicleText() {
      return vehicle.year + ' ' + vehicle.make + ' ' + vehicle.model;
    }

    if (vsel) {
      var yearSel = vsel.querySelector('[data-vsel-field="year"]');
      var makeSel = vsel.querySelector('[data-vsel-field="make"]');
      var modelSel = vsel.querySelector('[data-vsel-field="model"]');
      var confirmEl = vsel.querySelector('[data-vsel-confirm]');
      var hintEl = vsel.querySelector('[data-vsel-hint]');
      var propInput = vsel.querySelector('[data-vsel-input]');

      var MODELS = {};
      var modelsEl = vsel.querySelector('[data-vsel-models]');
      if (modelsEl) {
        try { MODELS = JSON.parse(modelsEl.textContent); } catch (e) { MODELS = {}; }
      }

      var markSet = function (el) {
        if (el) el.classList.toggle('is-set', !!el.value);
      };

      var syncVehicle = function () {
        vehicle.year = yearSel ? yearSel.value : '';
        vehicle.make = makeSel ? makeSel.value : '';
        vehicle.model = modelSel ? modelSel.value : '';

        [yearSel, makeSel, modelSel].forEach(markSet);

        // Only write the line item property once the vehicle is fully chosen —
        // Shopify drops properties whose value is empty.
        if (propInput) propInput.value = vehicleComplete() ? vehicleText() : '';

        if (confirmEl) {
          if (vehicleComplete()) {
            confirmEl.textContent = 'Confirmed: ' + vehicleText();
            confirmEl.hidden = false;
          } else {
            confirmEl.hidden = true;
            confirmEl.textContent = '';
          }
        }
        if (hintEl) hintEl.hidden = vehicleComplete();

        refreshAtc();
      };

      if (makeSel && modelSel) {
        makeSel.addEventListener('change', function () {
          var list = MODELS[makeSel.value] || [];
          modelSel.innerHTML = '';

          var first = document.createElement('option');
          first.value = '';
          first.textContent = list.length ? 'Model' : 'Select Make First';
          modelSel.appendChild(first);

          list.forEach(function (name) {
            var opt = document.createElement('option');
            opt.value = name;
            opt.textContent = name;
            modelSel.appendChild(opt);
          });

          modelSel.disabled = list.length === 0;

          // A single-model make can be chosen for the customer.
          if (list.length === 1) modelSel.value = list[0];

          syncVehicle();
        });

        modelSel.addEventListener('change', syncVehicle);
      }
      if (yearSel) yearSel.addEventListener('change', syncVehicle);
    }

    /* ── Add to cart state ── */
    function refreshAtc() {
      if (!atcBtn || !atcLabel) return;
      var v = currentVariant();

      if (v && !v.available) {
        atcBtn.disabled = true;
        atcLabel.textContent = 'SOLD OUT';
        return;
      }
      if (!vehicleComplete()) {
        atcBtn.disabled = true;
        atcLabel.textContent = 'SELECT YOUR VEHICLE';
        return;
      }
      atcBtn.disabled = false;
      atcLabel.textContent = 'ADD TO CART — ' + (v ? (v.price_money || money(v.price)) : '');
    }

    function updateForVariant() {
      var v = currentVariant();
      for (var i = 1; i <= maxPos; i++) {
        var label = variantsRoot && variantsRoot.querySelector('[data-fm-selected-label="' + i + '"]');
        if (label && selected[i]) label.textContent = selected[i];
      }
      if (v) {
        if (hiddenId) hiddenId.value = v.id;
        if (priceEl) priceEl.textContent = v.price_money || money(v.price);
        if (compareEl && saveEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = money(v.compare_at_price);
            compareEl.hidden = false;
            saveEl.textContent = 'SAVE ' + money(v.compare_at_price - v.price);
            saveEl.hidden = false;
          } else {
            compareEl.hidden = true;
            saveEl.hidden = true;
          }
        }
      }
      refreshAtc();
    }

    if (variantsRoot) {
      variantsRoot.querySelectorAll('.pdp-swatch, .pdp-optbtn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pos = parseInt(btn.dataset.fmOptPos, 10);
          selected[pos] = btn.dataset.fmOptValue;
          variantsRoot.querySelectorAll('[data-fm-opt-pos="' + pos + '"]').forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          updateForVariant();
        });
      });
    }

    /* Guard: never submit without a vehicle, even if the button is re-enabled. */
    var form = document.getElementById('fm-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!vehicleComplete()) {
          e.preventDefault();
          if (vsel && typeof vsel.scrollIntoView === 'function') {
            vsel.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      });
    }

    refreshAtc();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var mainImg = document.getElementById('pdp-main-img');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.pdp-gallery__thumb'));

    /* ── Image data for gallery + lightbox ── */
    var images = [];
    var imagesEl = document.querySelector('[data-pdp-images]');
    if (imagesEl) {
      try { images = JSON.parse(imagesEl.textContent); } catch (e) { images = []; }
    }

    var currentIndex = 0;
    /* Replaced by the carousel block below when the strip is present. */
    var scrollActiveThumbIntoView = function () {};

    function setMainImage(index, animate) {
      if (!mainImg || !images.length) return;
      if (index < 0) index = 0;
      if (index > images.length - 1) index = images.length - 1;
      currentIndex = index;
      var img = images[index];
      function apply() {
        mainImg.src = img.src;
        mainImg.alt = img.alt || '';
        mainImg.dataset.index = index;
        if (animate) mainImg.style.opacity = '1';
      }
      if (animate) {
        mainImg.style.opacity = '0';
        setTimeout(apply, 140);
      } else {
        apply();
      }
      thumbs.forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.dataset.index, 10) === index);
      });
      scrollActiveThumbIntoView();
    }

    /* ── Thumbnail clicks ── */
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setMainImage(parseInt(btn.dataset.index, 10), true);
      });
    });

    /* ── Thumbnail carousel ──
       One click scrolls by exactly one tile (thumb width + gap), read from
       the rendered elements so the CSS stays the single source of truth. */
    var thumbNav = document.querySelector('[data-thumbnav]');
    var thumbViewport = document.querySelector('[data-thumb-viewport]');
    var thumbPrev = document.querySelector('[data-thumb-prev]');
    var thumbNext = document.querySelector('[data-thumb-next]');

    if (thumbNav && thumbViewport && thumbPrev && thumbNext && thumbs.length) {
      var step = function () {
        var first = thumbs[0];
        var strip = first.parentElement;
        var gap = parseFloat(getComputedStyle(strip).columnGap || getComputedStyle(strip).gap) || 0;
        return first.getBoundingClientRect().width + gap;
      };

      var maxScroll = function () {
        return thumbViewport.scrollWidth - thumbViewport.clientWidth;
      };

      function syncArrows() {
        var max = maxScroll();
        // 1px tolerance: sub-pixel layout can leave scrollLeft just shy of max.
        var scrollable = max > 1;
        thumbNav.setAttribute('data-scrollable', scrollable ? 'true' : 'false');
        thumbPrev.disabled = !scrollable || thumbViewport.scrollLeft <= 1;
        thumbNext.disabled = !scrollable || thumbViewport.scrollLeft >= max - 1;
      }

      thumbPrev.addEventListener('click', function () {
        thumbViewport.scrollLeft -= step();
        syncArrows();
      });

      thumbNext.addEventListener('click', function () {
        thumbViewport.scrollLeft += step();
        syncArrows();
      });

      thumbViewport.addEventListener('scroll', syncArrows, { passive: true });
      window.addEventListener('resize', syncArrows);

      /* Keeps the selected thumb visible — matters when a colour variant
         swaps the main image and the active thumb sits outside the window. */
      scrollActiveThumbIntoView = function () {
        var active = thumbs.filter(function (b) {
          return b.classList.contains('is-active');
        })[0];
        if (!active) return;
        var vp = thumbViewport.getBoundingClientRect();
        var box = active.getBoundingClientRect();
        if (box.left < vp.left) {
          thumbViewport.scrollLeft -= (vp.left - box.left);
        } else if (box.right > vp.right) {
          thumbViewport.scrollLeft += (box.right - vp.right);
        }
        syncArrows();
      };

      syncArrows();
    }

    /* ── Lightbox ── */
    var lb = document.getElementById('pdp-lightbox');
    var lbImg = document.getElementById('pdp-lb-img');
    var lbCounter = document.getElementById('pdp-lb-counter');
    var lbIndex = 0;

    function renderLightbox() {
      if (!images.length) return;
      var img = images[lbIndex];
      lbImg.src = img.full || img.src;
      lbImg.alt = img.alt || '';
      if (lbCounter) lbCounter.textContent = (lbIndex + 1) + ' / ' + images.length;
    }

    function openLightbox(index) {
      if (!lb || !images.length) return;
      lbIndex = index || 0;
      renderLightbox();
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (!lb) return;
      lb.hidden = true;
      document.body.style.overflow = '';
    }

    function lbStep(dir) {
      lbIndex = (lbIndex + dir + images.length) % images.length;
      renderLightbox();
    }

    var mainBtn = document.getElementById('pdp-main-btn');
    if (mainBtn) {
      mainBtn.addEventListener('click', function () { openLightbox(currentIndex); });
    }

    if (lb) {
      var lbClose = document.getElementById('pdp-lb-close');
      var lbPrev = document.getElementById('pdp-lb-prev');
      var lbNext = document.getElementById('pdp-lb-next');
      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      if (lbPrev) lbPrev.addEventListener('click', function () { lbStep(-1); });
      if (lbNext) lbNext.addEventListener('click', function () { lbStep(1); });
      lb.addEventListener('click', function (e) {
        if (e.target === lb) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowLeft') lbStep(-1);
        else if (e.key === 'ArrowRight') lbStep(1);
      });
    }

    /* ── Variant selectors (color swatches + configuration buttons) ── */
    var variantsRoot = document.getElementById('pdp-variants');
    var variantData = [];
    var variantsEl = document.querySelector('[data-pdp-variants]');
    if (variantsEl) {
      try { variantData = JSON.parse(variantsEl.textContent); } catch (e) { variantData = []; }
    }

    if (variantsRoot && variantData.length) {
      var optBtns = Array.prototype.slice.call(variantsRoot.querySelectorAll('.pdp-swatch, .pdp-optbtn'));
      var maxPos = 0;
      optBtns.forEach(function (b) {
        var p = parseInt(b.dataset.optPos, 10);
        if (p > maxPos) maxPos = p;
      });

      var selected = [];
      for (var i = 1; i <= maxPos; i++) {
        var active = variantsRoot.querySelector('.is-active[data-opt-pos="' + i + '"]');
        selected[i] = active ? active.dataset.optValue : null;
      }

      var hiddenId = document.getElementById('pdp-variant-id');
      var priceEl = document.getElementById('pdp-price');
      var compareEl = document.getElementById('pdp-compare');
      var saveEl = document.getElementById('pdp-save');
      var atcBtn = document.getElementById('pdp-atc');
      var atcLabel = document.getElementById('pdp-atc-label');

      function findVariant() {
        return variantData.find(function (v) {
          for (var i = 1; i <= maxPos; i++) {
            if (selected[i] && v['option' + i] !== selected[i]) return false;
          }
          return true;
        });
      }

      function formatCents(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function updateForVariant() {
        var v = findVariant();
        // Update visible selected-value labels
        for (var i = 1; i <= maxPos; i++) {
          var label = variantsRoot.querySelector('[data-selected-label="' + i + '"]');
          if (label && selected[i]) label.textContent = selected[i];
        }
        if (!v) return;

        if (hiddenId) hiddenId.value = v.id;

        var money = v.price_money || formatCents(v.price);
        if (priceEl) priceEl.textContent = money;

        if (compareEl && saveEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = formatCents(v.compare_at_price);
            compareEl.hidden = false;
            saveEl.textContent = 'SAVE ' + formatCents(v.compare_at_price - v.price);
            saveEl.hidden = false;
          } else {
            compareEl.hidden = true;
            saveEl.hidden = true;
          }
        }

        if (atcBtn && atcLabel) {
          if (v.available) {
            atcBtn.disabled = false;
            atcLabel.textContent = 'ADD TO CART — ' + money;
          } else {
            atcBtn.disabled = true;
            atcLabel.textContent = 'SOLD OUT';
          }
        }

        // Color → switch the main product image to the variant's photo
        if (v.image_id != null) {
          for (var k = 0; k < images.length; k++) {
            if (images[k].id === v.image_id) {
              setMainImage(images[k].index, true);
              break;
            }
          }
        }
      }

      optBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pos = parseInt(btn.dataset.optPos, 10);
          selected[pos] = btn.dataset.optValue;
          variantsRoot.querySelectorAll('[data-opt-pos="' + pos + '"]').forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          updateForVariant();
        });
      });
    }

    /* ── Confirm Your Truck (product-specific, year only) ── */
    var vsPanel = document.querySelector('.vehicle-sel');
    if (vsPanel) {
      var yearSel = vsPanel.querySelector('[data-vs="year"]');
      var confirmEl = document.getElementById('vs-confirm');
      var lockedMake = vsPanel.dataset.make || '';
      var lockedModel = vsPanel.dataset.model || '';

      if (yearSel) {
        yearSel.addEventListener('change', function () {
          if (!confirmEl) return;
          if (yearSel.value) {
            confirmEl.textContent = '✓ Confirmed fit: ' + yearSel.value + ' ' + (lockedMake + ' ' + lockedModel).trim();
            confirmEl.hidden = false;
          } else {
            confirmEl.hidden = true;
            confirmEl.textContent = '';
          }
        });
      }
    }

    /* ── Sticky tab nav ── */
    var tabNav = document.getElementById('pdp-tabnav');

    if (tabNav && window.IntersectionObserver) {
      /* Active tab tracking */
      var sectIds = ['pdp-sect-overview', 'pdp-sect-features', 'pdp-sect-installation', 'pdp-sect-reviews', 'pdp-sect-shipping'];
      var tabs = tabNav.querySelectorAll('.pdp-tabnav__tab');

      function setActiveTab(id) {
        tabs.forEach(function (tab) {
          var href = tab.getAttribute('href');
          if (href === '#' + id) {
            tab.classList.add('is-active');
          } else {
            tab.classList.remove('is-active');
          }
        });
      }

      var sectObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setActiveTab(entry.target.id);
          }
        });
      }, { threshold: 0.3, rootMargin: '-100px 0px -30% 0px' });

      sectIds.forEach(function (id) {
        var el = document.getElementById(id);
        if (el) sectObserver.observe(el);
      });

      /* Smooth scroll for tab clicks */
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          e.preventDefault();
          var target = document.querySelector(tab.getAttribute('href'));
          if (target) {
            var offset = 100 + 48;
            var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
